(function() {
    class BuildASet extends HTMLElement {
      constructor() {
        super();
        this.bundleItems = [];
        this.discountName = this.dataset.discountName
        this.discountPercentage = parseInt(this.dataset.discountPercentage) || 0
        this.minimumQuantity = parseInt(this.dataset.minimumQuantity) || 0

        this.setSummary = this.querySelector(".set__summary")
        this.closeSummary = this.querySelector(".set__summary-close")

        this.viewSetButton = this.querySelector(".set__view-set-button")
        this.progressBar = this.querySelector(".set__progress")

        this.emptySetText = this.querySelector(".set__progress-text").innerText
        this.progressBarText = this.querySelector(".set__progress-text")

        this.viewSetButton.addEventListener("click", this.onViewButtonClick.bind(this))
        this.closeSummary.addEventListener("click", this.onCloseSummaryClick.bind(this))
        
      }
  
      connectedCallback() {
        this.setupEventListeners();
        this.initializeProducts();
      }
  
      setupEventListeners() {
        this.addEventListener('click', this.handleClick.bind(this));
        this.addEventListener('change', this.handleQuantityChange.bind(this));
      }
  
      initializeProducts() {
        const productCards = this.querySelectorAll('.set-product-card');
        
        productCards.forEach(card => {
          const variantsScript = card.querySelector('.product-variants-data');
          if (variantsScript) {
            const variants = JSON.parse(variantsScript.textContent);
            card.variantsData = variants;
            
            const firstAvailableVariant = variants.find(v => v.available);
            if (firstAvailableVariant) {
              this.selectVariantOptions(card, firstAvailableVariant);
            }
          }
        });
      }
  
      handleClick(event) {
        const target = event.target;
        console.log(target)
  
        if (target.hasAttribute("type") && target.getAttribute("type") == "radio") {
          this.handleVariantSelection(target);
          console.log("variant changed")
        } else if (target.classList.contains('set-add-to-set')) {
          event.preventDefault();
          this.handleAddToSet(target);
        } else if (target.classList.contains('set-quantity-btn')) {
          this.handleQuantityButton(target);
        } else if (target.classList.contains('set-remove-item')) {
          this.handleRemoveItem(target);
        } else if (target.classList.contains('set__add-to-cart-button')) {
          this.handleAddToCart();
        }
      }
  
      handleVariantSelection(variant) {
        const card = variant.closest('.set-product-card');        
        this.updateVariantAvailability(card)
        this.updateFeaturedImage(card)
        this.updateAddToSetButton(card)
      }
  
      updateVariantAvailability(card) {
        const selectedOptions = this.getSelectedOptions(card);
        const variants = card.variantsData;
        
        const availableVariants = variants.filter(variant => {
          return selectedOptions.every((option, index) => {
            return !option || variant.options[index] === option;
          });
        });
  
        card.querySelectorAll('.set-variant-options').forEach((option, optionIndex) => {
          const variants = option.querySelectorAll('input[type="radio"]')
          // console.log(optionIndex)
          // console.log(variants)

          // variants.forEach(button => {
          //   const value = button.value

          //   const isAvailable = availableVariants.some(variant => 
          //     variant.options[optionIndex] === value && variant.available
          //   );

            
          //   button.classList.toggle('unavailable', !isAvailable);
          // })

          // const buttons = group.querySelectorAll('.set-variant-option');
          
          // buttons.forEach(button => {
          //   const value = button.dataset.optionValue;
          //   const isAvailable = availableVariants.some(variant => 
          //     variant.options[groupIndex] === value && variant.available
          //   );
            
          //   button.classList.toggle('unavailable', !isAvailable);
          // });


        });

      }

      onViewButtonClick(event) {
        this.setSummary.classList.add("visible")
        bodyTag.classList.add("overflow-hidden-mobile")
        event.preventDefault()
      }

      onCloseSummaryClick(event) {
        this.setSummary.classList.remove("visible")
        bodyTag.classList.remove("overflow-hidden-mobile")
        event.preventDefault()
      }

      updateFeaturedImage(card) {
        const featuredImageEl = card.querySelector(".product-images__featured")
        const selectedColorVariant = card.querySelector('[data-selected-value]')
        const selectedColor = card.querySelector(".swatch-input__input:checked")

        if (selectedColor) {
          const mediaSrc = selectedColor.dataset.featuredImage

          let image = document.createElement('img');

          image.addEventListener('load', (event) => {
            const { target } = event;
            target.classList.remove('loading');

            Array.from(featuredImageEl.childNodes).forEach((el) => {
              if (el != target) {
                el.remove();
              }
            });
          });

          image.classList.add('loading');
          image.src = mediaSrc;

          selectedColorVariant.innerText = selectedColor.value
          featuredImageEl.appendChild(image);
        }
        
        // image.alt = alt;
      }
  
      updateAddToSetButton(card) {
        const selectedOptions = this.getSelectedOptions(card);
        const variants = card.variantsData;
        const addButton = card.querySelector('.set-add-to-set');
        
        const selectedVariant = variants.find(variant => 
          variant.options.every((option, index) => option === selectedOptions[index])
        );
        
        if (selectedVariant && selectedVariant.available) {
          addButton.textContent = "Add to set"
          addButton.disabled = false;
          addButton.dataset.variantId = selectedVariant.id;
          
          const priceElement = card.querySelector('.current-price');
          priceElement.textContent = this.formatMoney(selectedVariant.price);
        } else {
          addButton.textContent = "Sold out"
          addButton.disabled = true;
          delete addButton.dataset.variantId;
        }
      }
  
      getSelectedOptions(card) {
        const options = [];
        const optionGroups = card.querySelectorAll('.set-variant-options');
        
        optionGroups.forEach(group => {
          const selectedVariant = group.querySelector('input[type="radio"]:checked');
          options.push(selectedVariant ? selectedVariant.value : null);
        });
        
        return options;
      }
  
      selectVariantOptions(card, variant) {
        this.updateVariantAvailability(card);
        this.updateAddToSetButton(card);
      }
  
      handleAddToSet(button) {
        const card = button.closest('.set-product-card');
        const variantId = button.dataset.variantId;
        const variants = card.variantsData;
        const variant = variants.find(v => v.id == variantId);
        
        console.log(variant)
        if (!variant) return;
        
        const pageTitle = document.querySelector("h1").textContent
        const productTitle = card.querySelector('.product__title h3').textContent;
        const selectedOptions = this.getSelectedOptions(card);
        
        const bundleItem = {
          variantId: variant.id,
          productTitle: productTitle,
          variantTitle: selectedOptions.join(' / '),
          price: variant.price,
          image: variant.featured_image?.src || card.querySelector('.set-product-image')?.src,
          quantity: 1,
          pageTitle: pageTitle
        };
        
        this.bundleItems.push(bundleItem);
        this.updateBundleDisplay();
      }
  
      handleQuantityButton(button) {
        const item = button.closest('.set__line-item');
        const index = parseInt(item.dataset.itemIndex);
        const isIncrease = button.textContent === '+';
        
        if (isIncrease) {
          this.bundleItems[index].quantity++;
        } else if (this.bundleItems[index].quantity > 1) {
          this.bundleItems[index].quantity--;
        }
        
        this.updateBundleDisplay();
      }
  
      handleQuantityChange(event) {
        if (event.target.classList.contains('set-quantity-input')) {
          const item = event.target.closest('.set__line-item');
          const index = parseInt(item.dataset.itemIndex);
          const newQuantity = parseInt(event.target.value) || 1;
          
          this.bundleItems[index].quantity = Math.max(1, newQuantity);
          this.updateBundleDisplay();
        }
      }
  
      handleRemoveItem(button) {
        const item = button.closest('.set__line-item');
        const index = parseInt(item.dataset.itemIndex);
        
        this.bundleItems.splice(index, 1);
        this.updateBundleDisplay();
      }
  
      updateBundleDisplay() {
        const itemsContainer = this.querySelector('.set__items');
        const pricingSection = this.querySelector('.set-pricing');
        const addToCartButton = this.querySelector('.set__add-to-cart-button');
        
        if (this.bundleItems.length === 0) {
          itemsContainer.innerHTML = '<div class="set-empty-set">Add products to your bundle to see them here</div>';

          addToCartButton.innerText =  this.emptySetText
          this.progressBar.style.width = "0%";
          this.progressBarText.innerText =  this.emptySetText

          pricingSection.style.display = 'none';
          return;
        }
        
        itemsContainer.innerHTML = this.bundleItems.map((item, index) => `
          <div class="set__line-item" data-item-index="${index}">
            ${item.image ? `<img src="${item.image}" alt="" class="set__line-item-image">` : ''}
            
            <div class="set__line-item-info">
              <div class="set__line-item-variant">
                <div class="set__line-item-title h5">${item.productTitle}</div>
                <div class="set__line-item-variant-title">${item.variantTitle}</div>
              </div>
              <div class="set__line-item-price">
                <span class="regular-price">${this.formatMoney(item.price)}</span>
                <span class="discounted-price">${this.formatMoney(item.price * (100 - this.discountPercentage) / 100)}</span><br>
                <span class="discount-name">${this.discountName}</span>
              </div>
            </div>

            <button class="set-remove-item" type="button">
              <span class="svg-wrapper"><svg xmlns="http://www.w3.org/2000/svg" class="icon icon-remove" viewBox="0 0 16 16"><path fill="currentColor" d="M14 3h-3.53a3.07 3.07 0 0 0-.6-1.65C9.44.82 8.8.5 8 .5s-1.44.32-1.87.85A3.06 3.06 0 0 0 5.53 3H2a.5.5 0 0 0 0 1h1.25v10c0 .28.22.5.5.5h8.5a.5.5 0 0 0 .5-.5V4H14a.5.5 0 0 0 0-1M6.91 1.98c.23-.29.58-.48 1.09-.48s.85.19 1.09.48c.2.24.3.6.36 1.02h-2.9c.05-.42.17-.78.36-1.02m4.84 11.52h-7.5V4h7.5z"></path><path fill="currentColor" d="M6.55 5.25a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5m2.9 0a.5.5 0 0 0-.5.5v6a.5.5 0 0 0 1 0v-6a.5.5 0 0 0-.5-.5"></path></svg>
              </span>
            </button>
          </div>
        `).join('');
        
        const subtotal = this.bundleItems.reduce((sum, item) => sum + (item.price * item.quantity), 0);
        const discount = Math.round(subtotal * this.discountPercentage / 100);
        const total = subtotal - discount;
        
        this.querySelector('.subtotal-amount').textContent = this.formatMoney(subtotal);
        this.querySelector('.discount-amount').textContent = '-' + this.formatMoney(discount);
        this.querySelector('.total-amount').textContent = this.formatMoney(total);
        
        pricingSection.style.display = 'block';

        console.log(this.bundleItems.length)

        if (this.bundleItems.length < this.minimumQuantity) {
          let width = (this.bundleItems.length / this.minimumQuantity) * 100

          addToCartButton.disabled = true
          console.log(this.bundleItems.length)
          addToCartButton.innerText = `${this.bundleItems.length} of ${this.minimumQuantity} added`

          this.progressBar.style.width = `${width}%`
          this.progressBarText.innerText = `${this.bundleItems.length} of ${this.minimumQuantity} added - View set`
        } else {
          addToCartButton.disabled = false;
  
          addToCartButton.innerText = `Add to Cart`

          this.progressBar.style.width = "100%";
          this.progressBarText.innerText = `View set`
        }
      }
  
      async handleAddToCart() {
        const items = this.bundleItems.map(item => ({
          id: item.variantId,
          quantity: item.quantity,
          properties: { "_Page": item.pageTitle}
        }));
        
        try {
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ items })
          });
          
          if (response.ok) {
            window.location.href = '/cart';
          } else {
            alert('Error adding items to cart. Please try again.');
          }
        } catch (error) {
          alert('Error adding items to cart. Please try again.');
        }
      }
  
      formatMoney(cents) {
        return new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: window.bundleStrings.currency
        }).format(cents / 100);
      }
    }
  
    customElements.define('build-a-set', BuildASet);
  })();